import { csv } from "d3-fetch";
import groupBy from "lodash/groupBy";
import JUDGES_2018 from "../data/2018__data-viz__judge-tallies.csv";
import JUDGES_2019 from "../data/2019__data-viz__judge-tallies.csv";
import topoToGeo from "./topoToGeo";
import { MISSING_COUNTIES, COUNTY_DATA_NOTES } from "./constants";

const judgeCleaner = (data) => {
  // Add new column: total days with no events
  return {
    id: data.judgeId,
    court: data.judgeCourt,
    county: data.judgeCounty,
    type: "judge",
    name: data.judgeName,
    firstNameWithInitial: data.judgeName.split(",")[1],
    lastName: data.judgeName.split(",")[0],
    label: data.judgeName,
    totalCaseEvents: +data.totalCaseEvents,
    totalCalendarEvents: +data.totalCalendarEvents,
    totalMiscEvents: +data.totalMiscEvents,
    avgEventsPerDay: +data.avgEventsPerDay,
    ndwDays: +data.ndwDays,
    totalDaysWithEvents: +data.totalDaysWithEvents,
    totalDaysWithNoEvents: +data.totalDaysWithNoEvents,
    daysWithOnlyEventsBefore1Pm: +data.daysWithOnlyEventsBefore1Pm,
    percDaysWithOnlyEventsBefore1Pm: +data.percDaysWithOnlyEventsBefore1Pm,
  };
};

const FIELDS_TO_AVG = [
  "totalCaseEvents",
  "totalCalendarEvents",
  "totalMiscEvents",
  "ndwDays",
  "totalDaysWithEvents",
  "totalDaysWithNoEvents",
  "daysWithOnlyEventsBefore1Pm",
  "percDaysWithOnlyEventsBefore1Pm",
];

const calcAvg = (arr, accessor) => {
  return (
    arr.reduce((accum, currentVal) => accum + +currentVal[accessor], 0) /
    arr.length
  );
};

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([
    csv(JUDGES_2018, judgeCleaner),
    csv(JUDGES_2019, judgeCleaner),
    import("~/data/pa-county.json"),
  ]).then(([judges2018, judges2019, topoJson]) => {
    const judges = { 2018: judges2018, 2019: judges2019 };
    const counties = {};
    Object.keys(judges).forEach((yearKey) => {
      const judgesData = judges[yearKey];
      const grouped = groupBy(judgesData, "county");
      // get aggregate county data
      counties[yearKey] = Object.keys(grouped).map((countyKey) => {
        const groupedData = grouped[countyKey];
        const note = COUNTY_DATA_NOTES[countyKey]
          ? COUNTY_DATA_NOTES[countyKey]
          : "";
        const avgs = {};
        FIELDS_TO_AVG.forEach((field) => {
          const keyName = `avg${field[0].toUpperCase()}${field.slice(1)}`;
          avgs[keyName] = calcAvg(groupedData, field);
        });
        return {
          id: countyKey,
          label: countyKey,
          type: "county",
          note,
          ...avgs,
        };
      });
      // add missing county values
      MISSING_COUNTIES.forEach(({ id, note }) => {
        counties[yearKey].push({
          id,
          label: id,
          type: "county",
          noData: true,
          note,
        });
      });
    });
    const data = {};
    data.geoJson = topoToGeo(topoJson, "pa-county");
    data.judges = judges;
    data.counties = counties;
    return data;
  });
};

export default loadData;
